exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".city-stores {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n}\n.city-stores__input_wrapper {\n  width: 400px;\n  margin: 0 0 30px;\n}\n.stores-left-side {\n  display: flex;\n  height: 100%;\n  flex-direction: column;\n  justify-content: space-between;\n}\n.create-store {\n  width: 100% !important;\n}\n.city-stores-list {\n  width: 90vw;\n}\n.city-stores-panel {\n  display: flex;\n  align-items: center;\n  color: #000000 !important;\n}\n.city-stores-panel > span:last-child {\n  color: #a7a8aa;\n}\n.city-stores-panel > span.region-name {\n  cursor: pointer;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/less-loader/dist/cjs.js?{"javascriptEnabled":true}!./src/scenes/CityStores/containers/Stores.less
// module id = 1121
// module chunks = 0